import { DataMap } from './Datas.Map';
import { SettingsLayout } from 'views/settings';
import { DataTableBusOffLine } from './tables/Datas.Table.BusOffLine';
import { SidePanel } from '_components';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { mapActions } from '_store';
import { AlertsTableReport } from '../alerts';


export { DataHome };

function DataHome() {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(mapActions.getLastPositions());
    }, []);

    return (
        <div >
            {<SettingsLayout />}
           {<DataMap />}
            <div className="p-10">
                {<AlertsTableReport limit={true}/>}
                {<DataTableBusOffLine />}
            </div>
            {<SidePanel />}
        </div>    
    );
}